import baseGoApi from './baseGoApi';
import {PaymentMethod} from "@stripe/stripe-js/dist/api/payment-methods";

interface CreateSubscriptionData {
    priceId: string;
    customerId: string;
}

interface UpdateSubscriptionData {
    priceId: string;
    customerId: string;
}

interface PaymentSetupData {
    customerId: string;
    paymentMethodId: string | null | PaymentMethod;
}


const subscriptionApi = {
    setupStripe: async () => {
        const response = await baseGoApi.get('/subscriptions/setup-stripe');
        return response.data;
    },
    setupStripeCustomer: async () => {
        const response = await baseGoApi.post('/subscriptions/setup-stripe-customer');
        return response.data;
    },
    createSubscription: async (data: CreateSubscriptionData) => {
        const response = await baseGoApi.post('/subscriptions', data);
        return response.data;
    },
    updateSubscription: async (subscriptionId: string, data: UpdateSubscriptionData) => {
        const response = await baseGoApi.put(`/subscriptions/${subscriptionId}`, data);
        return response.data;
    },
    setupStripeCustomerAfterPayment: async (data: PaymentSetupData) => {
        const response = await baseGoApi.post('/subscriptions/setup-stripe-customer', data);
        return response.data;
    }
};

export default subscriptionApi; 